export const getPaymentTypeTitle = (type: "deposit" | "withdraw") =>
  type === "deposit" ? "Deposit" : "Withdrawal";

export const checkForDigitsOnInput = (e) => /^\d+$/.test(e.key);

export const checkForInvalidChars = (e, extraSymArr: string[] = []) =>
  ["e", "E", "+", "-", ...extraSymArr].includes(e.key);

export const isValidAmountSeriesInput = (value) => {
  if (value == null || !value.trim()) {
    return true;
  }

  return value
    .trim()
    .split(",")
    .map((item) => item.trim())
    .every((part) => /^\d+$/.test(part));
};

export const parseAmountSeriesInput = (value) => {
  if (value == null || !value.trim()) {
    return [];
  }

  return value
    .split(",")
    .map((item) => parseInt(item.trim(), 10))
    .sort((a, b) => a - b);
};

export const isUniqueAmountSeries = (value) => {
  if (!isValidAmountSeriesInput(value)) {
    return true;
  }

  const amounts = parseAmountSeriesInput(value);

  return new Set(amounts).size === amounts.length;
};

export const formatAmountSeriesToInput = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item)).join(",");
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number") {
    return String(value);
  }

  return "";
};

export const formatAmountSeriesMap = (dataObj = {}) => {
  const result = {};

  for (const [key, value] of Object.entries(dataObj || {})) {
    result[key] = formatAmountSeriesToInput(value);
  }

  return result;
};

export const parseAmountSeriesMap = (dataObj = {}) => {
  const result = {};

  for (const [key, value] of Object.entries(dataObj || {})) {
    if (typeof value === "string") {
      result[key] = parseAmountSeriesInput(value);
    } else if (Array.isArray(value)) {
      result[key] = value.map((item) => parseInt(item, 10));
    } else if (typeof value === "number") {
      result[key] = [value];
    }
  }

  return result;
};

export const amountValuesToNumber = (dataObj) => {
  const result = {};

  for (const [key, value] of Object.entries(dataObj)) {
    if (typeof value === "string") {
      result[key] = parseInt(value);
    }

    if (typeof value === "number") {
      result[key] = value;
    }

    if (Array.isArray(value)) {
      result[key] = value.map((item) => parseInt(item));
    }
  }

  return result;
};

export const arrayValuesToString = (valueList) => {
  if (Array.isArray(valueList)) {
    return valueList.sort((a, b) => a - b).map((item) => item.toString());
  }

  return [];
};

export const preparePaymentInputValue = (value) =>
  !!value.length ? JSON.parse(value) : {};

export const isEmptyArray = (value) => Array.isArray(value) && !value.length;

export const isNoRemainderDivision = (
  baseValue: number | Array<number>,
  divisor: number = 1
) => {
  if (Array.isArray(baseValue)) {
    return (
      baseValue.length === 0 ||
      baseValue.every((value) => value % divisor === 0)
    );
  } else {
    return !baseValue || (baseValue > 0 && baseValue % divisor === 0);
  }
};

export const checkForMultiplicity = (payload) =>
  Object.keys(payload.amount_multiplicity).every((currency) => {
    const divisor = payload.amount_multiplicity[currency];
    const amountDefault = payload.amount_default[currency];
    const amountSeries = payload.amount_series[currency];

    if (!divisor || (!amountDefault && !amountSeries)) {
      return true;
    }

    const isNoRemainderAmountDefault = isNoRemainderDivision(
      amountDefault,
      divisor
    );

    const isNoRemainderAmountSeries = isNoRemainderDivision(
      amountSeries,
      divisor
    );

    return isNoRemainderAmountDefault && isNoRemainderAmountSeries;
  });
